import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function Payments() {

  const [payments, setPayments] = useState([]);

  const [form, setForm] = useState({
    customer: "",
    plot: "",
    amount: "",
    paid: "",
    balance: "",
    method: "Cash",
    transaction: "",
    status: "Paid"
  });

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    setPayments([
      ...payments,
      form
    ]);

    setForm({
      customer: "",
      plot: "",
      amount: "",
      paid: "",
      balance: "",
      method: "Cash",
      transaction: "",
      status: "Paid"
    });
  };

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div className="main-content">

        <h1>Payments</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="customer"
            placeholder="Customer Name"
            value={form.customer}
            onChange={handleChange}
          />

          <input
            type="text"
            name="plot"
            placeholder="Plot Number"
            value={form.plot}
            onChange={handleChange}
          />

          <input
            type="number"
            name="amount"
            placeholder="Total Amount"
            value={form.amount}
            onChange={handleChange}
          />

          <input
            type="number"
            name="paid"
            placeholder="Paid Amount"
            value={form.paid}
            onChange={handleChange}
          />

          <input
            type="number"
            name="balance"
            placeholder="Balance"
            value={form.balance}
            onChange={handleChange}
          />

          <select
            name="method"
            value={form.method}
            onChange={handleChange}
          >
            <option>Cash</option>
            <option>UPI</option>
            <option>Bank Transfer</option>
            <option>Cheque</option>
          </select>

          <input
            type="text"
            name="transaction"
            placeholder="Transaction ID"
            value={form.transaction}
            onChange={handleChange}
          />

          <select
            name="status"
            value={form.status}
            onChange={handleChange}
          >
            <option>Paid</option>
            <option>Pending</option>
          </select>

          <button type="submit">
            Add Payment
          </button>

        </form>

      </div>

    </div>
  );
}

export default Payments;